import { useEffect, useState } from 'react';
import WindowContext from './WindowContext';
import JavascriptBridge from '@/utils/JavascriptBridge';

type WebKitType = {
  messageHandlers: {
    OsvcMobileAppBridge_v1: any;
  };
};

// In the future we can add more methods here for incoming calls
// Also we can define a type that has the various messages
type MessengerType = {
  endChat(message: any): void;
};

declare global {
  interface Window {
    prechatMessenger: MessengerType;
    webkit: WebKitType;
    OsvcMobileAppBridge_v1: any;
    endChat(message: any): void;
  }

  interface Window {
    __CSRBuddy__: any;
  }
}

interface PageProps {
  children: React.ReactNode;
}

const WindowProvider = ({ children }: PageProps) => {
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    window.prechatMessenger = {
      endChat: () => {
        window.dispatchEvent(
          new CustomEvent('nma_bridge:message', {
            detail: {
              messageType: 'endChat'
            }
          })
        );
      }
    };

    window.endChat = () => {
      window.dispatchEvent(
        new CustomEvent('nma_bridge:message', {
          detail: {
            messageType: 'endChat'
          }
        })
      );
    };
  }, []);

  return (
    <WindowContext.Provider
      value={{
        javascriptBridge: JavascriptBridge.getInstance()
      }}
    >
      {children}
    </WindowContext.Provider>
  );
};

export default WindowProvider;
